<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        @if (!condtag) {
            <li class="dl-nodemenu__item" data-uitleg="quantity_space_element" (click)="uitvoerNewQuantitySpaceElement('top')" title="{{ 'ADD_QS_ELEM_TOP' | translate }}">
                <a class="value_top"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="quantity_space_element" (click)="uitvoerNewQuantitySpaceElement('bottom')" title="{{ 'ADD_QS_ELEM_BOTTOM' | translate }}">
                <a class="value_bottom"></a>
            </li>
        }
        @if (!condtag || condtag.state === 'cons') {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('quantity_correspondence_menu')" title="{{ 'CORR_SUBMENU' | translate }}">
                <a class="correspondence_general"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
    @if (actievSubmenu() === 'quantity_correspondence_menu') {
        <ul class="dl-nodemenu__submenu">
            @if (!condtag || condtag.state === 'cons') {
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qs_directed" [class.selectedMenuItem]="isActiefInitAddActie('correspondence_qs_directed')" (click)="uitvoerInitAddAction({type: 'correspondence_qs_directed'})" title="{{ 'ADD_CORR_DIRECTED' | translate }}">
                    <a class="correspondence_directed"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qs_normal" [class.selectedMenuItem]="isActiefInitAddActie('correspondence_qs_normal')" (click)="uitvoerInitAddAction({type: 'correspondence_qs_normal'})" title="{{ 'ADD_CORR_NORMAL' | translate }}">
                    <a class="correspondence_normal"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qs_directed_reverse" [class.selectedMenuItem]="isActiefInitAddActie('correspondence_qs_directed_reverse')" (click)="uitvoerInitAddAction({type: 'correspondence_qs_directed_reverse'})" title="{{ 'ADD_CORR_DIR_REV' | translate }}">
                    <a class="correspondence_directed_reverse"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qs_reverse" [class.selectedMenuItem]="isActiefInitAddActie('correspondence_qs_reverse')" (click)="uitvoerInitAddAction({type: 'correspondence_qs_reverse'})" title="{{ 'ADD_CORR_REV' | translate }}">
                    <a class="correspondence_reverse"></a>
                </li>
            }
        </ul>
    }
</div>
